import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=19500aa7&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=ts"
export * from "./Step3.vue?vue&type=script&lang=ts"
import style0 from "./Step3.vue?vue&type=style&index=0&id=19500aa7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19500aa7",
  null
  
)

export default component.exports